import { render, staticRenderFns } from "./userLogout.vue?vue&type=template&id=5402c9b0"
import script from "./userLogout.vue?vue&type=script&lang=js"
export * from "./userLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports